import React from 'react';

import SvgIcon from './SvgIcon';

const MessageFull = props => (
    <SvgIcon {...props}>
        <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="map-tools" transform="translate(-1146.000000, -463.000000)" fill="#FFFFFF" fillRule="nonzero">
                <g id="Group" transform="translate(1117.000000, 148.000000)">
                    <g id="APPROVAL" transform="translate(10.000000, 315.000000)">
                        <g id="message" transform="translate(19.500000, 0.000000)">
                            <path
                                d="M16,5.96875 L16,13.8487595 C16,14.2395038 15.7333333,14.5 15.3333333,14.5 L15.3333333,14.5 L0.666666667,14.5 C0.266666667,14.5 9.66338121e-13,14.2395038 9.66338121e-13,13.8487595 L9.66338121e-13,13.8487595 L9.66338121e-13,5.96875 L7.06666667,9.68082061 C7.33333333,9.87619275 7.66666667,9.94131679 8,9.94131679 C8.33333333,9.94131679 8.66666667,9.87619275 8.93333333,9.68082061 L8.93333333,9.68082061 L16,5.96875 Z M15.3333333,1.5 C15.7333333,1.5 16,1.76590909 16,2.16477273 L16,2.16477273 L16,4.15909091 C16,4.425 15.8666667,4.62443182 15.6666667,4.75738636 L15.6666667,4.75738636 L8.33333333,8.74602273 C8.2,8.8125 8.13333333,8.8125 8,8.8125 C7.86666667,8.8125 7.8,8.8125 7.66666667,8.74602273 L7.66666667,8.74602273 L0.333333333,4.75738636 C0.133333333,4.62443182 9.66338121e-13,4.425 9.66338121e-13,4.15909091 L9.66338121e-13,4.15909091 L9.66338121e-13,2.16477273 C9.66338121e-13,1.76590909 0.266666667,1.5 0.666666667,1.5 L0.666666667,1.5 Z"
                                id="Combined-Shape"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

MessageFull.displayName = 'MessageFullIcon';

export default MessageFull;
